import React from 'react'

export default function RulesManagement() {
  const data:any = [
    {role:"In-Patient Hositalization"},
    {role: 'Outpatient Treat ^v'},
    {role:"Day Case"},
   

  ];
  return (
    <div className=' container'style={{margin:"30px"}} >
      {/* title */}
      <h5>Rules Management Screen <span> <i className="bi bi-virus"></i> </span> <span><a href="" style={{marginLeft:"30px"}}>Click to Download template</a></span>   </h5>
{/* first row input */}
<div className=' row'>
<div className="input-group w-50  m-3">
  <input type="file" className="form-control" id="inputGroupFile04" aria-describedby="inputGroupFileAddon04" aria-label="Upload"/>
  
  <button className="btn btn-secondary" type="submit"  style={{marginLeft:"10px", padding:"8px"}}> <span className=' m-1 '><i className="fa-solid fa-upload"></i></span>Upload</button>
</div>

</div>
{/* second row input */}

{/* <div className=' row d-flex flex-row w-100 ' style={{ marginTop:"20px"}}>
 <select name="tpa" id=""className='  p-1 ' style={{marginLeft:"7px",width:"30%"}}>
  

<option value="tpa">TPA/Insurance Company</option>

 </select>
 <select name="NetworkName" id=""className='  p-1 ' style={{marginLeft:"7px",width:"20%"}}>
  

  <option value="NetworkName">Network Name</option>
  
   </select>
   <select name="PlanName" id=""className='  p-1 ' style={{marginLeft:"7px",width:"20%"}}>
  

  <option value="PlanName">Plan Name</option>
  
   </select>
   <select name="ActivityType" id=""className='  p-1 ' style={{marginLeft:"7px",width:"20%"}}>
  

  <option value="ActivityType">Activity Type</option>
  
   </select>



</div> */}
{/* third row input */}

{/* <div className=' row d-flex flex-row w-100 ' style={{ marginTop:"20px"}}>
<input type="text" className="form-control " placeholder="Frequency "style={{marginLeft:"7px",width:"20%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>

<input type="Number" className="form-control " placeholder="Age "style={{marginLeft:"7px",width:"20%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>
<input type="text" className="form-control " placeholder="Gender "style={{marginLeft:"7px",width:"20%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>

   <input type="text" className="form-control " placeholder="Search "style={{marginLeft:"7px",width:"20%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>




</div> */}
<div className='row p-3  shadow-lg' style={{marginTop:"20px"}}>
    <div className="col-md-6 d-flex flex-column  align-items-center  "> 

   <input                  type="text" className="form-control "  placeholder="Company Name "style={{marginBottom:"7px",width:"50%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>
   <input  type="text" className="form-control " placeholder="NetworkName "style={{marginBottom:"7px",width:"50%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>
   <input  type="text" className="form-control " placeholder="Plan Name "style={{marginBottom:"7px",width:"50%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>

   <input  type="text" className="form-control " placeholder="Activity Type "style={{marginBottom:"7px",width:"50%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>

   <button className="btn btn-success" data-bs-toggle="modal" data-bs-target="#exampleModal">
            Add New Rules Management
          </button>
             </div>


    <div className="col-md-6 d-flex flex-column  align-items-center   " >
    <input type="text" className="form-control text-center " placeholder=" "style={{marginBottom:"7px",width:"50%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>
    <button className=' btn btn-success' style={{width:"25%"}}>Search</button>

    </div>

</div>
<div className="modal fade " id="exampleModal"  aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">Add Item</h5>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"> </button>
                </div>
              
                <div className=' container d-flex flex-column align-items-center '>
  
                <label className='m-2'>Company Name :</label>

                <select   name="Company Name" id=""className=' text-center  p-1 ' style={{marginBottom:"10px",width:"50%"}}>
  

  <option value=""></option>
  
   </select>

   <label className='m-2'>NetworkName :</label>

   <select name="NetworkName" id=""className='  p-1 ' style={{marginBottom:"10px",width:"50%"}}>
  

  <option value=""></option>
  
   </select>
   <label className='m-2'>PlanName :</label>

   <select name="PlanName" id=""className='  p-1 ' style={{marginBottom:"10px",width:"50%"}}>
  

  <option value=""></option>
  
   </select>
   <label className='m-2'>Activity Type :</label>

   <select name="ActivityType" id=""className='  p-1 ' style={{marginBottom:"10px",width:"50%"}}>
  

  <option value=""></option>
  
   </select>
   <label className='m-2'>Frequency  :</label>
   <input type="text" className="form-control " placeholder=" "style={{marginBottom:"10px",width:"50%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>

   <span>
   <label className='m-2'> Gender :</label>

<span style={{marginRight:"10px"}}> Male: <input type="radio" name='gender' /> </span>
                      <span> Female: <input type="radio" name='gender' /> </span>
</span>

   <label className='m-2'>Age :</label>

 <input type="Number" className="form-control " placeholder=" "style={{marginBottom:"10px",width:"50%"}} aria-label="Recipient's username" aria-describedby="basic-addon2"/>



        </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-primary"   >
                  Add Item
                  
                  </button>
                  <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                </div>
              </div>
            </div>
          </div>
{/* table */}
<table style={{  width: '80%' , marginTop:"40px", color:"white"  }}>
<thead className=' bg-success'>
        <tr>
      
          <th style={{ border: '1px solid #ddd', padding: '15px' }}>Company Name</th>
          <th style={{ border: '1px solid #ddd', padding: '15px' }}></th>
          <th style={{ border: '1px solid #ddd', padding: '15px' }}></th>
          <th style={{ border: '1px solid #ddd', padding: '15px' }}></th>
          <th style={{ border: '1px solid #ddd', padding: '15px' }}></th>
          <th style={{ border: '1px solid #ddd', padding: '15px' }}></th>
         <th style={{ border: '1px solid #ddd', padding: '15px' }} className=' text-center'></th>
        </tr>
      </thead>
      <tbody>
        {data.map((item:any,index:number) => (
          <tr key={item.id}  style={{
            // background: index % 2 === 0 ? '#74C0FC' : '#ffffff', // 
            border: '1px solid #ddd',
            padding: '8px',
            color:"black"
          }}>
            <td style={{ border: '1px solid #ddd', padding: '5px' }}>{item.role}</td>
            <td style={{ border: '1px solid #ddd', padding: '10px' }}></td>
            <td style={{ border: '1px solid #ddd', padding: '10px' }}></td>
            <td style={{ border: '1px solid #ddd', padding: '10px' }}></td>
            <td style={{ border: '1px solid #ddd', padding: '10px' }}></td>
            <td style={{ border: '1px solid #ddd', padding: '10px' }}></td>
          </tr>
          
        ))}
      </tbody>
    </table>

    </div>
  )
}
